import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { distinctUntilChanged, filter, switchMap } from 'rxjs'

import { OnboardPersistState, persistence, persistStateFactory } from '../state/persistence'

const persistPatientState$ = persistStateFactory(persistence.patientApiUrl)

const [patientPersistedStateChange$, setPatientPersistedState] = createSignal<OnboardPersistState>()

export { setPatientPersistedState }

export const [useOnboardPatientPersist, persistedPatientState$] = bind(
  patientPersistedStateChange$.pipe(
    filter(({ state }) => state !== 'createAccountPersist'),
    distinctUntilChanged((prev, next) => prev.state === next.state),
    switchMap(persistPatientState$),
  ),
  {
    loading: false,
    result: null,
    called: false,
  },
)
